export const footerStyles = {
    backgroundColor: '#ffffff',
    padding: '10px',
    textAlign: 'center',
    marginTop: '10px',
    marginLeft: '10px',
    position: 'fixed',
    width: '98%',
    bottom: '0',
};